// // src/Dashboard.js
// import React, { useContext, useState } from 'react';
// import { useDispatch, useSelector } from 'react-redux';
// import { useHistory, useLocation, useNavigate } from 'react-router-dom';
// import { userLogout } from '../Features/Slice';
// // import MyCoursesPage from './MyCoursesPage';
// import ProfilePage from "../components/ProfilePage"
// import MyCoursesPage from "../components/MyCoursesPage"
// import '../CSS/Dashboard.css';
// import Swal from 'sweetalert2';
// import { Context } from './Context';
// import AllAffiliates from './AllAffiliates';
// import AllUsers from './AllUsers';
// import AdminPostCourse from './AdminPostCourse';
// import AdminViewAllCourses from './AdminViewAllCourses';
// import AllAuthors from './AllAuthors';
// import PendingOrders from './PendingOrders';
// import AffiliateSearchAndDetails from './AffiliateSearchAndDetails';



// const Dashboard = () => {
//   const {activePage, setActivePage}=useContext(Context)
//   const userInfo = useSelector(state=>state.userInfo)
//   const location = useLocation();
  
 
//   const dispatch = useDispatch();
//   const navigate = useNavigate()
//   // const history = useHistory();

//   const handleLogout = () => {
//     Swal.fire({
//       icon: 'warning',
//       // title: 'Sign Up Successful',
//       text: 'Are you sure you want to logout?',
//       confirmButtonText: 'Yes',
//       showCancelButton:true
//     }).then((result) => {
//       if (result.isConfirmed) { 
//         dispatch(userLogout());
//       }
//     });
//   };
  

//   const navigateToCart = () => {
//     navigate('/cart'); // Assuming '/cart' is your cart route
//   };

//   const [adminswitch,setAdminSwitch]=useState(false)
//   const [adminMenu,setAdminMenu]=useState(0)


//   return (
//     <div key={location.pathname}>
//       {adminswitch===false?<div className="dashboard">
//       <nav className="dashboard-nav">
//         <button onClick={() => setActivePage('profile')}>Profile</button>
//         <button onClick={() => setActivePage('courses')}>My Courses</button>
//         <button onClick={handleLogout}>Logout</button>
      
//       </nav>
//       <div className="dashboard-content">
//         {activePage === 'profile' && <ProfilePage />}
//         {activePage === 'courses' && <MyCoursesPage />}
//       </div>
//     </div>:
//     <div className='AdminDashboard'>
//       <div className='AdminDashboardMenu'>
//           <p onClick={()=>setAdminMenu(0)} className={adminMenu===0?'AdminDashboardMenuPActive':'AdminDashboardMenuP'}>Users</p>
//           <p onClick={()=>setAdminMenu(1)} className={adminMenu===1?'AdminDashboardMenuPActive':'AdminDashboardMenuP'}>Affiliates</p>
//           <p onClick={()=>setAdminMenu(2)} className={adminMenu===2?'AdminDashboardMenuPActive':'AdminDashboardMenuP'}>Authors</p>
//           <p onClick={()=>setAdminMenu(3)} className={adminMenu===3?'AdminDashboardMenuPActive':'AdminDashboardMenuP'}>Pending Orders</p>
//           <p onClick={()=>setAdminSwitch(false)} className='AdminDashboardMenuP'>Switch to User</p>
//       </div>
//       <div className='AdminDashboardContentWrap'>
//           {/* {adminMenu===1&&<AllAffiliates/>} */}
//           {adminMenu===1&&<AffiliateSearchAndDetails/>}
//           {adminMenu===0&&<AllUsers/>}
//           {adminMenu===2&&<AllAuthors/>}
//           {adminMenu===3&&<PendingOrders/>}
          

//       </div>
      
//       </div>}
//     </div>

//   );
// };

// export default Dashboard;




// src/Dashboard.js
import React, { useContext, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { userLogout } from '../Features/Slice';
import ProfilePage from "../components/ProfilePage";
import MyCoursesPage from "../components/MyCoursesPage";
import Swal from 'sweetalert2';
import { Context } from './Context';
import AllAffiliates from './AllAffiliates';
import AllUsers from './AllUsers';
import AdminPostCourse from './AdminPostCourse';
import AdminViewAllCourses from './AdminViewAllCourses';
import AllAuthors from './AllAuthors';
import PendingOrders from './PendingOrders';
import AffiliateSearchAndDetails from './AffiliateSearchAndDetails';
import styled from 'styled-components';
import TrainingResgistrations from './TrainingRegistrations';
import { FaLongArrowAltRight } from 'react-icons/fa';
import { FaPowerOff } from 'react-icons/fa6';
import KidsApplicationsList from './KidsApplicationsList';

const Dashboard = () => {
  const { activePage, setActivePage } = useContext(Context);
  const userInfo = useSelector(state => state.userInfo);
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [adminMenu, setAdminMenu] = useState(0);

  const handleLogout = () => {
    Swal.fire({
      icon: 'warning',
      text: 'Are you sure you want to logout?',
      confirmButtonText: 'Yes',
      showCancelButton: true,
      confirmButtonColor: '#3b82f6',
      cancelButtonColor: '#ef4444'
    }).then((result) => {
      if (result.isConfirmed) { 
        dispatch(userLogout());
      }
    });
  };

  return (
    <DashboardWrapper key={location.pathname}>
      {/* Sidebar for Desktop / Dropdown for Mobile */}
      <Sidebar>
        <SidebarHeader>
          <h3>Dashboard</h3>
          <UserEmail>{userInfo?.email || 'Welcome Back'}</UserEmail>
          
        </SidebarHeader>
        <FaPowerOff onClick={handleLogout}/>

        {/* Mobile Dropdown Selector */}
        <MobileDropdown 
          value={activePage} 
          onChange={(e) => setActivePage(e.target.value)}
        >
          <option value="profile">Profile</option>
          <option value="courses">My Courses</option>
        {userInfo.role==='admin'&&  <>
           <option value="users">Users</option>
          <option value="affiliates">Affiliates</option>
          <option value="authors">Authors</option>
          <option value="orders">Pending Orders</option>
            <option value="trainingregistrations">Traning Registrations</option>
            <option value="kidstrainingregistrations">Kids Traning Registrations</option>
           
          </>}
     
        </MobileDropdown>

        {/* Desktop Navigation Links */}
        <NavLinksList>
          <NavCategoryTitle>General</NavCategoryTitle>
          <NavItem 
            active={activePage === 'profile'} 
            onClick={() => setActivePage('profile')}
          >
            👤 Profile
          </NavItem>
          <NavItem 
            active={activePage === 'courses'} 
            onClick={() => setActivePage('courses')}
          >
            📚 My Courses
          </NavItem>
{userInfo.role==="admin"&&<>
      <NavCategoryTitle>Administration</NavCategoryTitle>
          <NavItem 
            active={activePage === 'users'} 
            onClick={() => { setActivePage('users'); setAdminMenu(0); }}
          >
            👥 All Users
          </NavItem>
          <NavItem 
            active={activePage === 'affiliates'} 
            onClick={() => { setActivePage('affiliates'); setAdminMenu(1); }}
          >
            🤝 Affiliates
          </NavItem>
          <NavItem 
            active={activePage === 'authors'} 
            onClick={() => { setActivePage('authors'); setAdminMenu(2); }}
          >
            ✍️ Authors
          </NavItem>
          <NavItem 
            active={activePage === 'orders'} 
            onClick={() => { setActivePage('orders'); setAdminMenu(3); }}
          >
            Pending Orders
          </NavItem>
           <NavItem 
            active={activePage === 'trainingregistrations'} 
            onClick={() => { setActivePage('trainingregistrations'); setAdminMenu(4); }}
          >
            Training Registrations
          </NavItem>

           <NavItem 
            active={activePage === 'kidstrainingregistrations'} 
            onClick={() => { setActivePage('kidstrainingregistrations'); setAdminMenu(5); }}
          >
            Kids Training Registrations
          </NavItem>
</>}
        
        </NavLinksList>

        <LogoutContainer>
          <LogoutButton onClick={handleLogout}>
            🚪 Logout
          </LogoutButton>
        </LogoutContainer>
      </Sidebar>

      {/* Main Content Area */}
      <ContentArea>
        {activePage === 'profile' && <ProfilePage />}
        {activePage === 'courses' && <MyCoursesPage />}
        {activePage === 'users' && <AllUsers />}
        {activePage === 'affiliates' && <AffiliateSearchAndDetails />}
        {activePage === 'authors' && <AllAuthors />}
        {activePage === 'orders' && <PendingOrders />}
        {activePage === 'trainingregistrations' && <TrainingResgistrations/>}
   {activePage === 'kidstrainingregistrations' && <KidsApplicationsList/>}
      </ContentArea>
    </DashboardWrapper>
  );
};

export default Dashboard;

// --- Modern Styled Components ---
const DashboardWrapper = styled.div`
  display: flex;
  min-height: 100vh;
  background-color: #f8fafc;
  font-family: inherit;
  padding-top:50px;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

const Sidebar = styled.aside`
  width: 280px;
  background: #ffffff;
  border-right: 1px solid #e2e8f0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 24px;
  box-shadow: 2px 0 4px rgba(0, 0, 0, 0.02);

  @media (max-width: 768px) {
    width: 100%;
    padding: 16px;
    box-shadow: none;
    border-right: none;
    border-bottom: 1px solid #e2e8f0;
  }
`;

const SidebarHeader = styled.div`
  margin-bottom: 24px;

  h3 {
    font-size: 1.3rem;
    color: #0f172a;
    margin: 0 0 4px 0;
    font-weight: 700;
  }

  @media (max-width: 768px) {
    margin-bottom: 12px;
  }
`;

const UserEmail = styled.p`
  font-size: 0.85rem;
  color: #64748b;
  margin: 0;
  word-break: break-all;
`;

const NavLinksList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  flex-grow: 1;

  @media (max-width: 768px) {
    display: none; /* Hide standard list on mobile, use dropdown instead */
  }
`;

const MobileDropdown = styled.select`
  display: none;
  width: 100%;
  padding: 12px;
  border-radius: 8px;
  border: 1px solid #cbd5e1;
  background-color: #ffffff;
  font-size: 1rem;
  font-weight: 500;
  color: #0f172a;
  outline: none;
  margin-top: 8px;

  @media (max-width: 768px) {
    display: block;
  }
`;

const NavCategoryTitle = styled.span`
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #94a3b8;
  font-weight: 700;
  margin: 16px 0 6px 4px;
`;

const NavItem = styled.button`
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  padding: 12px 16px;
  border: none;
  border-radius: 8px;
  background-color: ${({ active }) => (active ? '#eff6ff' : 'transparent')};
  color: ${({ active }) => (active ? '#2563eb' : '#334155')};
  font-weight: ${({ active }) => (active ? '600' : '500')};
  font-size: 0.95rem;
  cursor: pointer;
  text-align: left;
  transition: all 0.2s ease;

  &:hover {
    background-color: #f1f5f9;
    color: #1e293b;
  }
`;

const LogoutContainer = styled.div`
  margin-top: 20px;
  border-top: 1px solid #f1f5f9;
  padding-top: 16px;

  @media (max-width: 768px) {
    display: none; /* Can also keep or place inside mobile layout if preferred */
  }
`;

const LogoutButton = styled.button`
  width: 100%;
  padding: 12px 16px;
  border: none;
  border-radius: 8px;
  background-color: #fef2f2;
  color: #dc2626;
  font-weight: 600;
  font-size: 0.95rem;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background-color: #fee2e2;
  }
`;

const ContentArea = styled.main`
  flex-grow: 1;
  padding: 32px;
  overflow-y: auto;

  @media (max-width: 768px) {
    padding: 16px;
  }
`;